exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.exchange .vux-x-dialog-absolute .weui-dialog {\n    position: fixed !important;\n}\n.descripe .weui-dialog {\n    padding: 30px !important;\n}\n", ""]);

// exports
